import React from 'react';
import { Icon } from './Icon.js';
export const IconCaretDownFromLineFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M14.75,2H3.25c-.414,0-.75,.336-.75,.75s.336,.75,.75,.75H14.75c.414,0,.75-.336,.75-.75s-.336-.75-.75-.75Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("path", { d: "M13.682,5H4.318c-.638,0-1.226,.347-1.533,.906s-.287,1.242,.055,1.781l4.682,7.383c.323,.509,.875,.812,1.478,.812s1.155-.304,1.478-.812l4.682-7.383c.341-.539,.362-1.222,.055-1.781s-.895-.906-1.533-.906Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconCaretDownFromLineFill18.js.map